import { models } from '@kurtosys/ksys-app-template';
import { action, computed, observable } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { IPaginationChangeDetail } from '../../../models/commonTypes';
import { IPagingOptions } from '../models/IPagingOptions';

export class PaginationStore extends StoreBase {

	@observable recordIndex: number = 0;
	@observable pageSize: number = 0;

	@action
	async initialize(): Promise<void> {
		if (this.enabled) {
			const { appStore, eventBusStore } = this.storeContext;
			if (this.pageSize === 0) {
				this.pageSize = this.defaultPageSize;
			}
			const eventDetail: CustomEventInit<models.eventBus.IUpdatePaginationDetail> = {
				detail: {
					identifier: appStore.applicationId,
					pagingData: {
						pageSize: this.pageSize,
						recordIndex: this.recordIndex,
						totalRecords: this.dynamicRowCount,
					},
				},
			};
			eventBusStore.trigger(models.eventBus.EventType.updatePagination, eventDetail);
		}
	}

	@computed
	get pagingOptions(): IPagingOptions | undefined {
		return this.storeContext.appStore.pagingOptions;
	}

	@computed
	get enabled(): boolean {
		return this.pagingOptions !== undefined;
	}

	@computed
	get dynamicRowCount(): number {
		if (this.pagingOptions) {
			return this.getQueryValue(this.pagingOptions.dynamicRowCount);
		}
		return 0;
	}

	@computed
	get defaultPageSize(): number {
		return this.pagingOptions?.pageSize || 5;
	}

	public handleUpdate = async (customEvent: CustomEvent<IPaginationChangeDetail>) => {
		const { inputStore } = this.storeContext;
		const { identifier, newPagingData } = customEvent.detail;
		this.pageSize = newPagingData.pageSize;
		this.recordIndex = newPagingData.recordIndex;
		const values = {
			'ksys-pagination-page-size': this.pageSize,
			'ksys-pagination-record-index': this.recordIndex,
		};
		await inputStore.updateQueryInputs([identifier], values);
	}
}
